import * as React from "react";
import {
  ApolloClient,
  InMemoryCache,
  ApolloProvider,
  ApolloLink,
  DefaultOptions,
} from "@apollo/client";
import { onError } from "@apollo/client/link/error";
import { createUploadLink } from "apollo-upload-client";
import { useDispatch } from "context";

const ApolloWrapper = ({ children }: { children: React.ReactNode }) => {
  const dispatch = useDispatch();
  const errorLink = onError(({ graphQLErrors, networkError }) => {
    if (graphQLErrors) {
      graphQLErrors.map(({ message, locations, path }) =>
        console.log(
          `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`,
        ),
      );
    }

    if (networkError) {
      dispatch({ type: "setLeaders", leaders: { error: "Network error" } });
      console.log(`[Network error]: ${networkError}`);
    }
  });

  const link = ApolloLink.from([
    errorLink,
    createUploadLink({
      uri: "https://testnet-exchange-graph.elrond.com/graphql",
    }),
  ]);

  const defaultOptions: DefaultOptions = {
    watchQuery: {
      fetchPolicy: "no-cache",
      errorPolicy: "ignore",
    },
    query: {
      fetchPolicy: "no-cache",
      errorPolicy: "all",
    },
  };

  const client = new ApolloClient({
    cache: new InMemoryCache(),
    link,
    defaultOptions,
  });

  return <ApolloProvider client={client}>{children}</ApolloProvider>;
};

export default ApolloWrapper;
